const mq = window.matchMedia('(min-width: 990px)');
const sync = () => document.querySelectorAll('details.b-footer__col').forEach((d) => { d.open = mq.matches; });
mq.addEventListener('change', sync);
sync();
document.addEventListener('click', (e) => {
  const summary = e.target.closest('.b-footer__col > summary');
  if (summary && mq.matches) e.preventDefault();
});
